import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MDBDatePickerComponent, ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { EstadoMaquinaService } from 'src/app/services/estado-maquina.service';
import { FamiliaService } from 'src/app/services/familia.service';
import { GrupoMaquinaService } from 'src/app/services/grupo-maquina.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { TipoDTEService } from 'src/app/services/tipo-dte.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProveedorComponent } from 'src/app/views/shared/modal-seleccionar-proveedor/modal-seleccionar-proveedor.component';
import { debounceTime, filter } from 'rxjs/operators';
import { MaquinaService } from 'src/app/services/maquina.service';
import { MaquinaFamiliaService } from 'src/app/services/maquina-familia.service';
import { TipoDestinatarioService } from 'src/app/services/tipo-destinatario.service';
import { MaquinaMovimientoService } from 'src/app/services/maquina-movimiento.service';
import * as _ from 'lodash';
import { RubroService } from 'src/app/services/rubro.service';

@Component({
  selector: 'app-maquinas-maestro-modal-add-edit',
  templateUrl: './modal-add-edit.component.html',
  styleUrls: ['../maquinas-maestro.component.scss'],
  providers: [SecurityService],
})
export class MaquinasMaestroModalAddEditComponent implements OnInit {
  // Outputs
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();
  @Output() onEditRowButtons: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild(ModalSeleccionarProveedorComponent, { static: true }) modalSeleccionarProveedor: ModalSeleccionarProveedorComponent;
  @ViewChild('addEditMaquina', { static: true }) addEditMaquinaModal: ModalDirective;
  @ViewChild('dpFechaMain', { static: true }) dpFechaMain: MDBDatePickerComponent;
  @ViewChild('dpFechaDetalle', { static: true }) dpFechaDetalle: MDBDatePickerComponent;
  @Output() onProveedorChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() public mode: 'ADD' | 'EDIT';

  formHeader: FormGroup;

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalCodigo: number;
  public rutUsuario: number;
  loading: boolean = false;
  headerData: any = {};

  proveedorSeleccionado: any = null;

  optionsGrupo: Array<any> = [];
  optionsTipoDoc: Array<any> = [];
  optionsTipoDocGarantia: Array<any> = [];
  optionsFamilia: Array<any> = [];
  optionsProveedor: Array<any> = [];
  optionsEstado: Array<any> = [];
  optionsRubro: Array<any> = [];
  optionsTipoDestinatario: Array<any> = [];

  // Utils
  private log: any;

  ubicacion: any;
  rutCliente: any;
  /** Con contrato deshabilitado (mov. cerrado), .value puede ser undefined; getRawValue refleja el estado real. */
  get mostrarFilasContrato(): boolean {
    return this.formHeader && this.formHeader.getRawValue().contrato === true;
  }
  buttonLoad: boolean = false;
  NumeroPlacaAnterior: string = null;
  AbrirModificar: number = 0;
  private currentPayload: any = null;
  movCerrado: boolean = false;
  private ultimoMovimiento: any = null;

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private rutService: RutService,
    private maquinaFamiliaService: MaquinaFamiliaService,
    private tipoDTEService: TipoDTEService,
    private datesService: DatesService,
    private grupoMaquinaService: GrupoMaquinaService,
    private estadoMaquinaService: EstadoMaquinaService,
    private rubroService: RubroService,
    private maquinaService: MaquinaService,
    private tipoDestinatarioService: TipoDestinatarioService,
    private maquinaMovimientoService: MaquinaMovimientoService
  ) {
    this.log = this.clog.log('MAQUINAS ADD/EDIT');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());

    this.loadFamilias();
    this.loadGrupos();
    this.loadEstados();
    this.loadRubros();
    this.loadTiposDte();
    this.loadTiposDestinatario();
    this.loadTiposDteGarantia();
    this.createForms();
    this.formChangesSubscriptions();
  }

  /** Indica si la fila de máquina trae número de contrato informado (misma lógica que antes con nroContratoGar). */
  private tieneDatosContratoEnMov(mov: any): boolean {
    if (!mov || mov.numero_contrato == null || mov.numero_contrato === '') {
      return false;
    }
    const n = Number(mov.numero_contrato);
    return !isNaN(n) && n > 0;
  }

  /** Marca el checkbox Contrato al editar si ya hay datos guardados (número y/o fechas). */
  private debeMarcarContratoDesdeMov(mov: any): boolean {
    if (this.tieneDatosContratoEnMov(mov)) {
      return true;
    }
    return !!(mov && (mov.fecha_contrato || mov.fecha_vigencia_contrato || mov.fecha_termino_contrato));
  }

  private aplicarValidatorsContrato(contratoActivo: boolean) {
    const nro = this.formHeader.get('nroContratoGar');
    const fDoc = this.formHeader.get('fechaDocGar');
    const fDesde = this.formHeader.get('fechaVigenciaDesdeGar');
    const fHasta = this.formHeader.get('fechaVigenciaHastaGar');
    const req = contratoActivo ? [Validators.required] : [];
    nro.setValidators(req);
    fDoc.setValidators(req);
    fDesde.setValidators(req);
    fHasta.setValidators(req);
    nro.updateValueAndValidity({ emitEvent: false });
    fDoc.updateValueAndValidity({ emitEvent: false });
    fDesde.updateValueAndValidity({ emitEvent: false });
    fHasta.updateValueAndValidity({ emitEvent: false });
  }

  /** Fecha de contrato / vigencia sin valor (null, undefined o string vacío). */
  private esValorFechaContratoVacio(v: any): boolean {
    return v == null || v === '';
  }

  /**
   * Al activar contrato sin datos previos (p. ej. se guardó sin contrato y se vuelve a chequear),
   * completa con la fecha de hoy para que el usuario no quede con pickers vacíos y validación required.
   */
  private aplicarFechasContratoPorDefectoSiVacias() {
    if (!this.formHeader) return;
    const now = this.datesService.CurrentDateToShortTimeString();
    const fDoc = this.formHeader.get('fechaDocGar');
    const fDesde = this.formHeader.get('fechaVigenciaDesdeGar');
    const fHasta = this.formHeader.get('fechaVigenciaHastaGar');
    if (fDoc && this.esValorFechaContratoVacio(fDoc.value)) {
      fDoc.setValue(now, { emitEvent: false });
    }
    if (fDesde && this.esValorFechaContratoVacio(fDesde.value)) {
      fDesde.setValue(now, { emitEvent: false });
    }
    if (fHasta && this.esValorFechaContratoVacio(fHasta.value)) {
      fHasta.setValue(now, { emitEvent: false });
    }
  }

  private getRutProveedorInput(): HTMLInputElement | null {
    return document.getElementById('rutProveedor') as HTMLInputElement;
  }

  private setRutProveedorReadonly(input: HTMLInputElement | null, readOnly: boolean) {
    if (!input) return;
    input.readOnly = readOnly;
  }

  private isNonEmptyArray<T>(value: any): value is T[] {
    return Array.isArray(value) && value.length > 0;
  }

  /** Mismo criterio que en capturarUltimoMovimientoCompleto: último por fecha_asignacion y codigo desc. */
  private sortMovimientosMaquinaDesc(movimientos: any): any[] {
    if (!Array.isArray(movimientos)) {
      return [];
    }
    return _.orderBy(
      movimientos,
      [
        (m) => (m && m.fecha_asignacion ? new Date(m.fecha_asignacion).getTime() : 0),
        (m) => (m && m.codigo != null ? Number(m.codigo) : 0),
      ],
      ['desc', 'desc']
    );
  }

  private crearInputParamsMovimientoMaqEsp(numeroPlaca: string) {
    return {
      filtro: {
        exacto: {
          empresa_rut: this.rutEmpresa,
          numero_placa: numeroPlaca,
        },
      },
      paginaActual: 10,
      cantidadRegistrosPorPagina: -1,
    };
  }

  private resolverNumeroDocumentoMovimiento(ultimoMovimiento: any, lastMov: any, mov: any): any {
    if (ultimoMovimiento && ultimoMovimiento.numero_documento_movimiento) {
      return ultimoMovimiento.numero_documento_movimiento;
    }
    if (lastMov && lastMov.numero_documento_movimiento) {
      return lastMov.numero_documento_movimiento;
    }
    return mov.numero_documento;
  }

  private aplicarCamposGarantiaAlForm(srcGar: any, mov: any) {
    const tipoGarMov = srcGar && srcGar.tipo_garantia_codigo != null ? Number(srcGar.tipo_garantia_codigo) : 0;
    this.formHeader.get('tipoDteGar').setValue(tipoGarMov > 0 ? srcGar.tipo_garantia_codigo : mov.tipo_garantia_codigo);
    this.formHeader.get('nroDocGar').setValue(
      srcGar && srcGar.nro_documento_garantia != null && String(srcGar.nro_documento_garantia).trim() !== ''
        ? srcGar.nro_documento_garantia
        : mov.nro_documento_garantia || null
    );
    this.formHeader.get('fechaDesdeGar').setValue(
      srcGar && srcGar.fecha_garantia ? srcGar.fecha_garantia : mov.fecha_garantia || null
    );
  }

  private aplicarCamposContratoAlForm(movContrato: any, mov: any) {
    let nroContrato: any = null;
    if (movContrato && movContrato.numero_contrato != null && movContrato.numero_contrato !== '') {
      nroContrato = movContrato.numero_contrato;
    } else if (mov.numero_contrato != null) {
      nroContrato = mov.numero_contrato;
    }
    this.formHeader.get('nroContratoGar').setValue(nroContrato);
    this.formHeader.get('fechaDocGar').setValue(
      movContrato && movContrato.fecha_contrato ? movContrato.fecha_contrato : mov.fecha_contrato || null
    );
    this.formHeader.get('fechaVigenciaDesdeGar').setValue(
      movContrato && movContrato.fecha_vigencia_contrato
        ? movContrato.fecha_vigencia_contrato
        : mov.fecha_vigencia_contrato || null
    );
    this.formHeader.get('fechaVigenciaHastaGar').setValue(
      movContrato && movContrato.fecha_termino_contrato
        ? movContrato.fecha_termino_contrato
        : mov.fecha_termino_contrato || null
    );
  }

  private poblarCabeceraFormDesdeMov(mov: any, lastMov: any, ultimoMovimiento: any) {
    this.formHeader.get('fechaConfirmacionEntrega').setValidators([]);
    this.formHeader.get('fechaDesdeGar').setValidators([]);
    this.formHeader.get('fechaDocGar').setValidators([]);
    this.formHeader.get('fechaDetalle').setValidators([]);

    this.formHeader.get('nroPlaca').setValue(mov.numero_placa);
    this.NumeroPlacaAnterior = mov.numero_placa;
    this.formHeader.get('activo').setValue(true);
    this.formHeader.get('marca').setValue(mov.nombre);
    this.formHeader.get('modelo').setValue(mov.modelo);
    this.formHeader.get('familia').setValue(mov.familia_maquina_codigo);
    this.formHeader.get('grupo').setValue(mov.grupo_maquina_codigo);
    this.formHeader.get('estado').setValue(mov.estado_maquina_codigo);
    this.formHeader.get('RubroSel').setValue(mov.codigo_rubro);
    this.formHeader.get('rutProveedor').setValue(this.rutService.AgregarDV(mov.proveedor_rut));
    this.formHeader.get('fechaMain').setValue(mov.fecha_compra);
    this.formHeader.get('observacion').setValue(mov.observacion);
    this.formHeader
      .get('tipoDte')
      .setValue(
        Number(mov.tipo_dte_codigo) === MaquinasMaestroModalAddEditComponent.CODIGO_GUIA_DESPACHO
          ? mov.tipo_dte_codigo
          : MaquinasMaestroModalAddEditComponent.CODIGO_GUIA_DESPACHO
      );
    this.bloquearTipoDteGuiaDespacho();
    this.formHeader.get('nroDoc').setValue(this.resolverNumeroDocumentoMovimiento(ultimoMovimiento, lastMov, mov));
    this.formHeader.get('fechaDetalle').setValue(mov.fecha_compra);
    this.formHeader.get('esMovimientoCerrado').setValue(mov.cerrado);

    const srcGar = ultimoMovimiento || lastMov;
    this.aplicarCamposGarantiaAlForm(srcGar, mov);

    const movContrato = ultimoMovimiento || lastMov;
    this.aplicarCamposContratoAlForm(movContrato, mov);

    this.formHeader.get('fechaConfirmacionEntrega').setValue(mov.fecha_entrega);
  }

  private getProveedorRutParaGuardar(rawRutProveedor: any): number | null {
    if (this.proveedorSeleccionado && this.proveedorSeleccionado.rut != null) {
      return Number(this.proveedorSeleccionado.rut);
    }
    const rutLimpio = this.rutService.Limpiar(rawRutProveedor);
    if (!rutLimpio) return null;
    return this.rutService.QuitarDV(rutLimpio);
  }

  private puedeEditarCompleto(movMaq: any[]): boolean {
    const len = movMaq ? movMaq.length : 0;
    if (len === 0) return true;
    if (len !== 1) return false;
    const rut = movMaq[0] ? movMaq[0].cliente_proveedor_rut : null;
    return rut === this.rutEmpresa || rut === 0;
  }

  private aplicarModoEdicionPorMovimiento(movMaq: any[], mov: any, rutProveedorInput: HTMLInputElement | null) {
    const edicionCompleta = this.puedeEditarCompleto(movMaq);

    // bandera para saber a qué función guardar se meterá después
    this.AbrirModificar = edicionCompleta ? 0 : 1;

    if (edicionCompleta) {
      this.formHeader.get('nroPlaca').enable();
      this.setRutProveedorReadonly(rutProveedorInput, false);
      this.buttonLoad = false;
      this.formHeader.get('fechaMain').enable();
      return;
    }

    this.formHeader.get('rutProveedor').disable();
    this.setRutProveedorReadonly(rutProveedorInput, true);
    // desactivar rut proveedor y fecha
    this.buttonLoad = true;
    this.formHeader.get('nroPlaca').disable();
    this.formHeader.get('fechaMain').disable();
    this.formHeader.get('tipoDestinatario').disable();
  }

  private aplicarTipoDestinatarioPorUbicacion(ubicacion: string | null | undefined) {
    const u = ubicacion || null;

    if (u == null || u.includes('CENTRO DE DISTRIBUCION') || u.includes('SIN ASIGNAR')) {
      this.formHeader.get('tipoDestinatario').setValue(1);
      return;
    }

    if (u.includes('CLIENTE')) {
      this.formHeader.get('tipoDestinatario').setValue(2);
      return;
    }

    if (u.includes('PROVEEDOR')) {
      this.formHeader.get('tipoDestinatario').setValue(99);
    }
  }

  private setControlEnabled(controlName: string, enabled: boolean) {
    const c = this.formHeader.get(controlName);
    if (!c) return;
    enabled ? c.enable() : c.disable();
  }

  /** Tipo DTE fijo (52 / GD): no se permite cambiar desde el UI. */
  private bloquearTipoDteGuiaDespacho(): void {
    const c = this.formHeader.get('tipoDte');
    if (!c) return;
    c.disable({ emitEvent: false });
  }

  private aplicarEstadoCerrado(cerrado: boolean) {
    const enabled = !cerrado;

    // cabecera
    this.setControlEnabled('marca', enabled);
    this.setControlEnabled('modelo', enabled);
    this.setControlEnabled('familia', enabled);
    this.setControlEnabled('grupo', enabled);
    this.setControlEnabled('esMovimientoCerrado', enabled);
    this.setControlEnabled('fechaConfirmacionEntrega', enabled);

    // detalle compra (tipo DTE siempre bloqueado — solo guía de despacho)
    this.setControlEnabled('nroDoc', enabled);
    this.setControlEnabled('fechaDetalle', enabled);

    // garantía / contrato
    this.setControlEnabled('tipoDteGar', enabled);
    this.setControlEnabled('nroDocGar', enabled);
    this.setControlEnabled('fechaDesdeGar', enabled);
    this.setControlEnabled('nroContratoGar', enabled);
    this.setControlEnabled('fechaDocGar', enabled);
    this.setControlEnabled('fechaVigenciaDesdeGar', enabled);
    this.setControlEnabled('fechaVigenciaHastaGar', enabled);
    this.setControlEnabled('contrato', enabled);

    this.bloquearTipoDteGuiaDespacho();
  }

  private loadFamilias() {
    this.maquinaFamiliaService.obtenerTodos(({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsFamilia = registros.map((p) => ({ value: p.codigo, label: p.nombre }));
    });
  }

  loadTiposDteGarantia() {
    this.tipoDTEService.obtenerTipoDocGarantia(({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsTipoDocGarantia = registros.map((p) => ({ value: p.codigo, label: p.nombre, ...p }));
    });
  }

  private loadGrupos() {
    this.grupoMaquinaService.obtenerTodos(({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsGrupo = registros.map((p) => ({ value: p.codigo, label: p.nombre }));
    });
  }

  loadEstados() {
    this.estadoMaquinaService.obtenerEstadosNoInactivo(({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsEstado = registros.map((p) => ({ value: p.codigo, label: p.nombre, ...p }));
    });
  }

  /** Solo guía de despacho (SII 52), descripción GD — único tipo en detalle de compra. */
  private static readonly CODIGO_GUIA_DESPACHO = 52;
  /** Texto visible en el combo (mismo criterio que antes: `nombre` del tipo DTE). */
  private static readonly NOMBRE_GUIA_DESPACHO_FALLBACK = 'Guía de despacho';

  loadTiposDte() {
    this.tipoDTEService.obtenerTipoCompra(({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.optionsTipoDoc = [
          {
            value: MaquinasMaestroModalAddEditComponent.CODIGO_GUIA_DESPACHO,
            label: MaquinasMaestroModalAddEditComponent.NOMBRE_GUIA_DESPACHO_FALLBACK,
            codigo: MaquinasMaestroModalAddEditComponent.CODIGO_GUIA_DESPACHO,
            nombre: MaquinasMaestroModalAddEditComponent.NOMBRE_GUIA_DESPACHO_FALLBACK,
          },
        ];
        return;
      }
      const { registros } = respuesta;
      const guia = (registros || []).find((p) => Number(p.codigo) === MaquinasMaestroModalAddEditComponent.CODIGO_GUIA_DESPACHO);
      const nombreApi = guia && guia.nombre ? String(guia.nombre).trim() : '';
      const nombreMostrar =
        nombreApi && nombreApi.toUpperCase() !== 'GD'
          ? nombreApi
          : MaquinasMaestroModalAddEditComponent.NOMBRE_GUIA_DESPACHO_FALLBACK;
      this.optionsTipoDoc = guia
        ? [{ value: guia.codigo, label: nombreMostrar, nombre: guia.nombre, ...guia }]
        : [
            {
              value: MaquinasMaestroModalAddEditComponent.CODIGO_GUIA_DESPACHO,
              label: MaquinasMaestroModalAddEditComponent.NOMBRE_GUIA_DESPACHO_FALLBACK,
              codigo: MaquinasMaestroModalAddEditComponent.CODIGO_GUIA_DESPACHO,
              nombre: MaquinasMaestroModalAddEditComponent.NOMBRE_GUIA_DESPACHO_FALLBACK,
            },
          ];
    });
  }

  loadTiposDestinatario() {
    this.tipoDestinatarioService.obtenerTodos(({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsTipoDestinatario = registros.filter((p) => p.codigo > 0).map((p) => ({ value: p.codigo, label: p.nombre, ...p }));
    });
  }

  private loadRubros() {
    this.rubroService.obtenerRubros(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      this.optionsRubro = registros.map((rubro) => ({ value: rubro.codigo, label: rubro.descripcion, ...rubro }));
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('RubroSel'), this.optionsRubro);
    });
  }

  private createForms() {
    this.formHeader = this.fb.group({
      activo: [true, [Validators.required]],
      nroPlaca: [null, [Validators.required]],
      marca: [null, [Validators.required]],
      modelo: [null, [Validators.required]],
      familia: [null, [Validators.required]],
      grupo: [[], [Validators.required]],
      estado: [null, [Validators.required]],
      RubroSel: [null, [Validators.required]],
      rutProveedor: ['907030008', [Validators.required]],
      fechaMain: [null, [Validators.required]],
      observacion: [null, []], //[Validators.required]],
      tipoDte: [null, [Validators.required]],
      nroDoc: [null, []], //[Validators.required]
      fechaDetalle: [null, [Validators.required]],
      tipoDestinatario: [{ value: 1, disabled: true }, []],
      tipoDteGar: [null, []],
      nroDocGar: [null, []],
      fechaDesdeGar: [null, []],
      contrato: [false, []],
      nroContratoGar: [null, []], // ADD/REMOVE dinamically Validators.required
      fechaDocGar: [null, []], // ADD/REMOVE dinamically Validators.required
      fechaVigenciaDesdeGar: [null, []], // ADD/REMOVE dinamically Validators.required
      fechaVigenciaHastaGar: [null, []], // ADD/REMOVE dinamically Validators.required
      fechaConfirmacionEntrega: [null, []],
      esMovimientoCerrado: [false, []],
    });
  }

  show() {
    // this.mode = 'ADD'
    this.log('mode', this.mode);
    this.addEditMaquinaModal.show();
    this.resetAndSetDefaults();
  }

  // REGISTROS EN EL EDITAR
  async load(mov) {
    this.movCerrado = mov.cerrado;
    // SI NO EXISTE MOVIMIENTO DE MAQUINA SE PUEDE REALIZAR UNA EDICION COMPLETA (ver puedeEditarCompleto)
    const inputParams = this.crearInputParamsMovimientoMaqEsp(mov.numero_placa);
    const movMaq = await this.capturarMovimientoMaquina(inputParams);
    const movMaqSorted = this.sortMovimientosMaquinaDesc(movMaq);
    const lastMov = movMaqSorted.length > 0 ? movMaqSorted[0] : null;
    this.ultimoMovimiento = await this.capturarUltimoMovimientoCompleto(mov.numero_placa);

    const rutProveedorInput = this.getRutProveedorInput();
    this.aplicarModoEdicionPorMovimiento(movMaqSorted, mov, rutProveedorInput);

    this.poblarCabeceraFormDesdeMov(mov, lastMov, this.ultimoMovimiento);

    this.ubicacion = mov.ubicacion;
    this.aplicarTipoDestinatarioPorUbicacion(this.ubicacion);

    this.aplicarEstadoCerrado(mov.cerrado === true);

    const marcarContrato = this.debeMarcarContratoDesdeMov(mov);
    this.formHeader.get('contrato').setValue(marcarContrato, { emitEvent: false });
    this.aplicarValidatorsContrato(marcarContrato);
    this.rutCliente = mov.cliente_proveedor_rut;
  }

  async capturarMovimientoMaquina(inputParams) {
    return new Promise((resolve) => {
      setTimeout(() => {
        this.maquinaMovimientoService.obtenerMovimientosMaqEsp(inputParams, ({ mensajes, respuesta }) => {
          const ok = respuesta !== null;
          if (!ok) {
            this.messageRendererService.showErrors(mensajes);
            resolve([]);
            return;
          }
          const { registros } = respuesta;
          this.show();
          resolve(registros);
        });
      }, 1000);
    });
  }

  private async capturarUltimoMovimientoCompleto(numeroPlaca: string) {
    const inputParams = {
      filtro: {
        exacto: {
          empresa_rut: this.rutEmpresa,
          numero_placa: numeroPlaca,
        },
      },
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1,
    };

    const movimientos: any[] = await new Promise((resolve) => {
      this.maquinaMovimientoService.obtenerMovimientos(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          resolve([]);
          return;
        }
        resolve((respuesta && respuesta.registros) || []);
      });
    });

    const sorted = this.sortMovimientosMaquinaDesc(movimientos);

    return sorted.length > 0 ? sorted[0] : null;
  }

  resetAndSetDefaults() {
    this.modalSeleccionarProveedor.clearLast();

    this.proveedorSeleccionado = null;

    if (this.mode === 'ADD') {
      this.dpFechaMain.clearDate();
      this.dpFechaDetalle.clearDate();
    }
    this.formValidatorsService.reset(this.formHeader);

    // set defaults
    const now = this.datesService.CurrentDateToShortTimeString();
    //* OBTENER PROVEEDOR NESTLE
    // activar boton de busqueda de rut
    this.buttonLoad = false;
    this.formHeader.get('rutProveedor').setValue('907030008');

    this.formHeader.get('activo').setValue(true);
    this.formHeader.get('fechaMain').setValue(now);
    this.formHeader.get('fechaDetalle').setValue(now);
    this.formHeader.get('fechaDesdeGar').setValue(now);
    this.formHeader.get('fechaConfirmacionEntrega').setValue(now);

    this.formHeader.get('contrato').enable();
    this.formHeader.get('contrato').setValue(false, { emitEvent: false });
    this.formHeader.get('nroContratoGar').setValue(null);
    this.formHeader.get('fechaDocGar').setValue(null);
    this.formHeader.get('fechaVigenciaDesdeGar').setValue(null);
    this.formHeader.get('fechaVigenciaHastaGar').setValue(null);
    this.aplicarValidatorsContrato(false);

    this.formHeader.get('nroPlaca').enable();
    this.formHeader.get('tipoDestinatario').setValue(1);
    this.formHeader.get('tipoDte').setValue(MaquinasMaestroModalAddEditComponent.CODIGO_GUIA_DESPACHO);
    this.bloquearTipoDteGuiaDespacho();
  }

  formChangesSubscriptions() {
    this.formHeader.get('contrato').valueChanges.subscribe((contrato: boolean) => {
      const activo = !!contrato;
      this.aplicarValidatorsContrato(activo);
      if (activo) {
        this.aplicarFechasContratoPorDefectoSiVacias();
      }
    });

    this.formHeader
      .get('rutProveedor')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rut: string) => {
        this.log(rut);
        //const _rut = this.rutService.QuitarDV(this.rutService.Limpiar(rut))
        this.modalSeleccionarProveedor.searchByRut(rut);
      });
  }

  abrirModalSeleccionarProveedor() {
    this.modalSeleccionarProveedor.show();
  }

  onProveedorSeleccionado({ data: _proveedorSeleccionado, origen }) {
    this.proveedorSeleccionado = _proveedorSeleccionado;
    this.proveedorSeleccionado.rutFormato = this.rutService.AgregarDV(this.proveedorSeleccionado.rut);
    this.formHeader.get('rutProveedor').setValue(this.proveedorSeleccionado.rutFormato);
    this.onProveedorChange.emit(this.headerData.proveedorSeleccionado);
    // this.modalSeleccionarProveedor.clearLast()
  }

  onProductoNoEncontrado() {
    this.clearProveedorSeleccionadoData();
  }

  clearProveedorSeleccionadoData() {
    this.proveedorSeleccionado = null;
    this.formHeader.get('rutProveedor').setValue(null);
  }

  guardar() {
    const valid = this.formValidatorsService.validate(this.formHeader);
    if (!valid) return;
    const nroPlacaIsDisabled = !this.formHeader.get('nroPlaca').enabled;
    this.formHeader.get('nroPlaca').enable();

    const raw = this.formHeader.getRawValue();
    const conContrato = raw.contrato === true;
    const proveedorRut = this.getProveedorRutParaGuardar(raw.rutProveedor);

    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        numero_placa: raw.nroPlaca,
        nombre: raw.marca,
        modelo: raw.modelo,
        familia_maquina_codigo: raw.familia,
        grupo_maquina_codigo: raw.grupo,
        estado_maquina_codigo: raw.estado,
        codigo_rubro: raw.RubroSel,
        proveedor_rut: proveedorRut,
        fecha_creacion: raw.fechaMain,
        observacion: raw.observacion,
        tipo_dte_codigo: raw.tipoDte,
        numero_documento: raw.nroDoc === '' ? null : raw.nroDoc,
        fecha_compra: raw.fechaDetalle,
        activo: true,
        ubicacion: raw.tipoDestinatario != null ? raw.tipoDestinatario.toString() : null,
        sucursal_codigo: this.sucursalCodigo,
        rut_usuario: this.rutUsuario,
        cliente_proveedor_rut: this.rutCliente,
        tipo_destinatario_codigo: raw.tipoDestinatario,

        // contrato (solo si el checkbox está marcado; igual criterio que al asignar)
        tipo_garantia_codigo: raw.tipoDteGar,
        nro_documento_garantia: raw.nroDocGar,
        fecha_garantia: raw.fechaDesdeGar,
        numero_contrato: conContrato ? raw.nroContratoGar : null,
        fecha_contrato: conContrato ? raw.fechaDocGar : null,
        fecha_vigencia_contrato: conContrato ? raw.fechaVigenciaDesdeGar : null,
        fecha_termino_contrato: conContrato ? raw.fechaVigenciaHastaGar : null,

        // entrega
        cerrado: raw.esMovimientoCerrado,
        fecha_entrega: raw.fechaConfirmacionEntrega,
      },
    };
    this.log('inputParams', JSON.stringify(inputParams));

    this.currentPayload = inputParams;

    if (nroPlacaIsDisabled) this.formHeader.get('nroPlaca').disable();

    this.loading = true;

    // this.log('mode', this.mode)
    // this.log(`ADD?`, this.mode === 'ADD' ? 'YES' : 'NO')
    // this.log(`EDIT?`, this.mode === 'EDIT' ? 'YES' : 'NO')
    // return

    if (this.mode === 'ADD') {
      this.maquinaService.agregar(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }
        const { empresa_rut } = respuesta;
        this.loading = false;
        this.onSuccess.emit();
        this.addEditMaquinaModal.hide();
        this.toastService.success('Operación exitosa');
      });
    } else if (this.mode === 'EDIT') {
      if (this.AbrirModificar == 1) {
        //ES POSIBLE MODIFICAR UNA PARTE DE LA VISTA

        this.maquinaService.guardar(inputParams, ({ mensajes, respuesta }) => {
          const ok = respuesta !== null;
          if (!ok) {
            this.messageRendererService.showErrors(mensajes);
            return;
          }
          const { empresa_rut } = respuesta;
          this.loading = false;
          // maquina.modificar (DAO Modificar) sincroniza el último maquina_movimiento en backend.
          this.onSuccess.emit();
          this.onEditRowButtons.emit(this.formHeader.get('estado').value);
          this.addEditMaquinaModal.hide();
          this.toastService.success('Operación exitosa');
        });
      } else {
        //ES POSIBLE MODIFICAR TODA LA VISTA
        const inputParams = _.cloneDeep(this.currentPayload);

        inputParams.entidad.numero_placa_ant = this.NumeroPlacaAnterior;
        console.log(inputParams);
        this.maquinaService.EditarMaquina(inputParams, ({ mensajes, respuesta }) => {
          const ok = respuesta !== null;
          if (!ok) {
            this.messageRendererService.showErrors(mensajes);
            return;
          }
          const { empresa_rut } = respuesta;
          this.loading = false;
          // DAO Modificar sincroniza último maquina_movimiento (misma lógica que modificar parcial).
          this.onSuccess.emit();
          this.onEditRowButtons.emit(this.formHeader.get('estado').value);
          this.addEditMaquinaModal.hide();
          this.toastService.success('Operación exitosa');
        });
      }
    }
  }

}
